import '../scss/app.scss';

import Swiper, { Navigation, Pagination, Autoplay, EffectFade } from 'swiper';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import 'swiper/css/effect-fade';

Swiper.use([Navigation, Pagination, Autoplay, EffectFade]);

const about = new Swiper('#about__swiper .swiper', {
  lazy: true,
  autoplay: true,
  loop: true,
  slidesPerView: 1,
  spaceBetween: 1,
  pagination: {
    el: '#about__swiper-pagination',
    type: 'bullets',
  },
  effect: 'fade',
});

const solution = new Swiper('#solution__swiper .swiper', {
  autoplay: false,
  loop: false,
  slidesPerView: 1.1,
  spaceBetween: 20,
  centeredSlides: true,
  breakpoints: {
    600: {
      slidesPerView: 'auto',
      spaceBetween: 20,
      centeredSlides: false,
      centeredSlidesBounds: true, // doesn't work with pagination
    },
  },
  navigation: {
    nextEl: '#solution__swiper-next',
    prevEl: '#solution__swiper-prev',
  },
  pagination: {
    el: '#solution__swiper-page-current',
    type: 'custom',
    renderCustom: function (swiper, current, total) {
      return current;
    },
  },
});

document.addEventListener('DOMContentLoaded', function () {
  let lazyloadImages;

  if ('IntersectionObserver' in window) {
    lazyloadImages = document.querySelectorAll('.is-lazy');
    const imageObserver = new IntersectionObserver(function (entries, observer) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          const image = entry.target;
          image.classList.remove('is-lazy');
          imageObserver.unobserve(image);
        }
      });
    });

    lazyloadImages.forEach(function (image) {
      imageObserver.observe(image);
    });
  } else {
    let lazyloadThrottleTimeout;
    lazyloadImages = document.querySelectorAll('.is-lazy');

    function lazyload() {
      if (lazyloadThrottleTimeout) {
        clearTimeout(lazyloadThrottleTimeout);
      }

      lazyloadThrottleTimeout = setTimeout(function () {
        var scrollTop = window.pageYOffset;
        lazyloadImages.forEach(function (img) {
          if (img.offsetTop < window.innerHeight + scrollTop) {
            img.src = img.dataset.src;
            img.classList.remove('is-lazy');
          }
        });
        if (lazyloadImages.length == 0) {
          document.removeEventListener('scroll', lazyload);
          window.removeEventListener('resize', lazyload);
          window.removeEventListener('orientationChange', lazyload);
        }
      }, 20);
    }

    document.addEventListener('scroll', lazyload);
    window.addEventListener('resize', lazyload);
    window.addEventListener('orientationChange', lazyload);
  }
});
(function () {
  const html = document.querySelector('html');
  const menu = document.getElementById('menu');
  const menuControl = document.getElementById('menu__control');
  const menuOpen = document.getElementById('menu__open');
  const menuClose = document.getElementById('menu__close');

  // page link
  function scrollToSmoothly(ev) {
    ev.preventDefault();

    if (html.classList.contains('menu-open')) {
      html.classList.remove('menu-open');
    }

    const id = ev.target.getAttribute('href').substr(1);
    const offset = id == 'about' ? 0 : -100; // menu height
    const pos = document.getElementById(id).offsetTop + offset;
    const currentPos = window.pageYOffset;
    let start = null;
    const time = 500;
    window.requestAnimationFrame(function step(currentTime) {
      start = !start ? currentTime : start;
      const progress = currentTime - start;
      if (currentPos < pos) {
        window.scrollTo(0, ((pos - currentPos) * progress) / time + currentPos);
      } else {
        window.scrollTo(0, currentPos - ((currentPos - pos) * progress) / time);
      }
      if (progress < time) {
        window.requestAnimationFrame(step);
      } else {
        window.scrollTo(0, pos);
      }
    });
  }
  document.querySelectorAll('[href^="#"]').forEach((el) => {
    el.addEventListener('click', (ev) => scrollToSmoothly(ev));
  });

  // on scroll
  let lastKnownScrollPosition = 0;
  let ticking = false;
  function menuOnScroll(scrollPos) {
    if (isPc()) {
      if (scrollPos > 1100) {
        menu.classList.add('is-active');
      } else if (scrollPos < 1100) {
        menu.classList.remove('is-active');
      }
    } else if (scrollPos >= 10) {
      html.classList.add('is-scrolled');
    } else if (scrollPos < 10) {
      html.classList.remove('is-scrolled');
    }
  }
  document.addEventListener('scroll', (event) => {
    lastKnownScrollPosition = window.scrollY;

    if (!ticking) {
      window.requestAnimationFrame(() => {
        menuOnScroll(lastKnownScrollPosition);
        ticking = false;
      });

      ticking = true;
    }
  });

  // menu
  menuOpen.addEventListener('click', (ev) => {
    html.classList.add('menu-open');
  });
  menuClose.addEventListener('click', (ev) => {
    html.classList.remove('menu-open');
  });

  // helper
  const isHidden = (elem) => {
    const styles = window.getComputedStyle(elem);
    return styles.display === 'none' || styles.visibility === 'hidden';
  };
  const isPc = (elem) => isHidden(menuControl);
})();
